import { inject, Injectable, signal } from '@angular/core';
import { of, Observable, Subscription, tap } from "rxjs";
import { saveAs } from "file-saver";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { protectedResources } from "../../auth-config";
import { StateStatus } from "../models/state-status.models";
import { catchError } from "rxjs/operators";
import { DocumentationType, LatestInstaller, LatestUserManual } from "../models/documentation.model";

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {
  http = inject(HttpClient);
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;
  status = signal<StateStatus>('pending');
  downloadSubscription;
  documentationTypeFileNameMap = [
    'User Manual.pdf',
    'CMX Empty.xlsx',
    'CMX SolidWorks Example.xlsx',
    'CMX Tekla Example.xlsx',
    'CMX Table Template.sldbomtbt',
    'Steelworks v0.swp',
    'objects.inp',
    '-Steelworks CMX v0.csv.rpt',
    'Cut Face & Case.pdf',
    'SteelworksInstaller.msi',
    'Weldment Profiles.zip'
  ]

  getLatestInstaller(): Observable<LatestInstaller> {
    return this.http.get<LatestInstaller>(this.brennerSoftwareApiEndpoint + `documentation/latestInstaller`);
  }

  getLatestUserManual(): Observable<LatestUserManual | null> {
    return this.http.get<LatestUserManual>(this.brennerSoftwareApiEndpoint + `documentation/latestUserManual`)
      .pipe(catchError(() => of(null)));
  }

  download(documentationType: DocumentationType, fileNameOverride?: string) {
    this.status.set('downloading');
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    this.downloadSubscription = this.http.get(this.brennerSoftwareApiEndpoint + `documentation/download/${documentationType}`, { responseType: "blob", observe: "response" })
      .pipe(
        catchError((err) => {
          this.status.set('downloadError')
          return of(null)
        }),
        tap(response => {
          if (!response?.body) return;
          const fileName = fileNameOverride
            || this.getFileNameFromResponse(response)
            || this.documentationTypeFileNameMap[documentationType];
          saveAs(response.body, fileName)
          this.status.set('downloadSuccess');
        })
      ).subscribe()
  }
  private getFileNameFromResponse(response: HttpResponse<unknown>): string | null {
    const disposition = response.headers.get('Content-Disposition');
    if (!disposition) return null;
    const utf8Match = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
    if (utf8Match?.[1]) {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
    }
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    return match?.[1] ? match[1].trim() : null;
  }

  ngOnDestroy() {
    this.downloadSubscription.unsubscribe();
  }
}
